import Vue from 'vue'
import wineClubComponent from '@@/js/vue/WineClub/WineClub.vue';
import store from '@@/js/vue/WineClub/store';

Vue.component('wine-club', wineClubComponent)

const wineClub = document.querySelector('wine-club');

wineClub && new Vue({store}).$mount(wineClub);